import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"
import { normalizePdf, normalizePhoto } from "../../utilities/Addons"

export const DELETE_LOCATION_PHOTO_BEGIN = "DELETE_LOCATION_PHOTO_BEGIN"
export const DELETE_LOCATION_PHOTO_ERROR = "DELETE_LOCATION_PHOTO_ERROR"
export const DELETE_LOCATION_PHOTO_SUCCESS = "DELETE_LOCATION_PHOTO_SUCCESS"
export const DELETE_LOCATION_PHOTO_RESET = "DELETE_LOCATION_PHOTO_RESET"

export const deleteLocationPhotoBegin = () => ({
	type: DELETE_LOCATION_PHOTO_BEGIN,
})

export const deleteLocationPhotoReset = () => ({
	type: DELETE_LOCATION_PHOTO_RESET,
})

export const deleteLocationPhotoError = (payload) => ({
	type: DELETE_LOCATION_PHOTO_ERROR,
	payload,
})

export const deleteLocationPhotoSuccess = (payload) => ({
	type: DELETE_LOCATION_PHOTO_SUCCESS,
	payload,
})

export function deleteLocationPhoto(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteLocationPhotoBegin())
		return fetch(`${URL}api/location-photo`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteLocationPhotoSuccess(json))
				return {
					photos_avant: json.photos_avant.map((p) =>
						normalizePhoto(p),
					),
					photos_apres: json.photos_apres.map((p) =>
						normalizePhoto(p),
					),
				}
			})
			.catch(
				catchApiError(dispatch, deleteLocationPhotoError, {
					silent: true,
				}),
			)
	}
}

export const DELETE_LOCATION_TRANSACTION_FILE_BEGIN =
	"DELETE_LOCATION_TRANSACTION_FILE_BEGIN"
export const DELETE_LOCATION_TRANSACTION_FILE_ERROR =
	"DELETE_LOCATION_TRANSACTION_FILE_ERROR"
export const DELETE_LOCATION_TRANSACTION_FILE_SUCCESS =
	"DELETE_LOCATION_TRANSACTION_FILE_SUCCESS"
export const DELETE_LOCATION_TRANSACTION_FILE_RESET =
	"DELETE_LOCATION_TRANSACTION_FILE_RESET"

export const deleteLocationTransactionFileBegin = () => ({
	type: DELETE_LOCATION_TRANSACTION_FILE_BEGIN,
})

export const deleteLocationTransactionFileReset = () => ({
	type: DELETE_LOCATION_TRANSACTION_FILE_RESET,
})

export const deleteLocationTransactionFileError = (payload) => ({
	type: DELETE_LOCATION_TRANSACTION_FILE_ERROR,
	payload,
})

export const deleteLocationTransactionFileSuccess = (payload) => ({
	type: DELETE_LOCATION_TRANSACTION_FILE_SUCCESS,
	payload,
})

export function deleteLocationTransactionFile(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteLocationTransactionFileBegin())
		return fetch(`${URL}api/location_transaction`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteLocationTransactionFileSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteLocationTransactionFileError))
	}
}

export const POST_LOCATION_TRANSACTION_FILE_BEGIN =
	"POST_LOCATION_TRANSACTION_FILE_BEGIN"
export const POST_LOCATION_TRANSACTION_FILE_RESET =
	"POST_LOCATION_TRANSACTION_FILE_RESET"
export const POST_LOCATION_TRANSACTION_FILE_ERROR =
	"POST_LOCATION_TRANSACTION_FILE_ERROR"
export const POST_LOCATION_TRANSACTION_FILE_SUCCESS =
	"POST_LOCATION_TRANSACTION_FILE_SUCCESS"

export const postLocationTransactionFileBegin = () => ({
	type: POST_LOCATION_TRANSACTION_FILE_BEGIN,
})

export const postLocationTransactionFileReset = () => ({
	type: POST_LOCATION_TRANSACTION_FILE_RESET,
})

export const postLocationTransactionFileError = (payload) => ({
	type: POST_LOCATION_TRANSACTION_FILE_ERROR,
	payload,
})

export const postLocationTransactionFileSuccess = (payload) => ({
	type: POST_LOCATION_TRANSACTION_FILE_SUCCESS,
	payload,
})

export function postLocationTransactionFile(formData) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postLocationTransactionFileBegin())
		return fetch(`${URL}api/location_transaction`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postLocationTransactionFileSuccess(json))
			})
			.catch(catchApiError(dispatch, postLocationTransactionFileError))
	}
}

export const FETCH_LOCATION_BEGIN = "FETCH_LOCATION_BEGIN"
export const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS"
export const FETCH_LOCATION_ERROR = "FETCH_LOCATION_ERROR"
export const FETCH_LOCATION_RESET = "FETCH_LOCATION_RESET"

export const fetchLocationBegin = () => ({
	type: FETCH_LOCATION_BEGIN,
})

export const fetchLocationSuccess = (payload) => ({
	type: FETCH_LOCATION_SUCCESS,
	payload,
})

export const fetchLocationError = (error) => ({
	type: FETCH_LOCATION_ERROR,
	payload: { error },
})

export const fetchLocationReset = () => {
	return (dispatch) => {
		dispatch({
			type: FETCH_LOCATION_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchLocation(id = null) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLocationBegin())
		let url = `${URL}api/locations`
		if (Number(id)) url = `${url}?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				json = {
					...json,
					location: {
						...json.location,
						// Photos laissées brutes : normalisées une seule fois par
						// formatLocationFromPayload (sinon double préfixage de URL).
						transactionsv2: [
							...json.location.transactionsv2.map((t) => ({
								...t,
								quittance: normalizePdf(t.quittance),
								facture: normalizePdf(t.facture),
							})),
						],
					},
				}
				dispatch(fetchLocationSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchLocationError))
	}
}

export const FETCH_LOCATION_VEHICULES_INDISPONIBLES_BEGIN =
	"FETCH_LOCATION_VEHICULES_INDISPONIBLES_BEGIN"
export const FETCH_LOCATION_VEHICULES_INDISPONIBLES_SUCCESS =
	"FETCH_LOCATION_VEHICULES_INDISPONIBLES_SUCCESS"
export const FETCH_LOCATION_VEHICULES_INDISPONIBLES_ERROR =
	"FETCH_LOCATION_VEHICULES_INDISPONIBLES_ERROR"
export const FETCH_LOCATION_VEHICULES_INDISPONIBLES_RESET =
	"FETCH_LOCATION_VEHICULES_INDISPONIBLES_RESET"

export const fetchLocationVehiculesIndisponiblesBegin = () => ({
	type: FETCH_LOCATION_VEHICULES_INDISPONIBLES_BEGIN,
})

export const fetchLocationVehiculesIndisponiblesSuccess = (payload) => ({
	type: FETCH_LOCATION_VEHICULES_INDISPONIBLES_SUCCESS,
	payload,
})

export const fetchLocationVehiculesIndisponiblesError = (payload) => ({
	type: FETCH_LOCATION_VEHICULES_INDISPONIBLES_ERROR,
	payload,
})

export const fetchLocationVehiculesIndisponiblesReset = () => ({
	type: FETCH_LOCATION_VEHICULES_INDISPONIBLES_RESET,
})

export function fetchLocationVehiculesIndisponibles(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLocationVehiculesIndisponiblesBegin())
		let url = `${URL}api/location-vehicules-indisponibles?`
		for (let key in kwargs) url += `${key}=${kwargs[key]}&`
		url = url.substring(0, url.length - 1)
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLocationVehiculesIndisponiblesSuccess(json))
				// Rendu à l'appelant : la fiche rattache la réponse à SA
				// requête (id + dates), cf. LocationV2.
				return json
			})
			.catch(
				catchApiError(
					dispatch,
					fetchLocationVehiculesIndisponiblesError,
				),
			)
	}
}

// GE-77 : dégâts « avant » proposés (derniers dégâts « après » du véhicule)
// pour l'aperçu au choix du véhicule. Pas de slice : la réponse est rendue à
// l'appelant, rattachée à SA requête (cf. LocationV2), comme les
// indisponibilités.
export const FETCH_LOCATION_DEGATS_PROPOSES_BEGIN =
	"FETCH_LOCATION_DEGATS_PROPOSES_BEGIN"
export const FETCH_LOCATION_DEGATS_PROPOSES_SUCCESS =
	"FETCH_LOCATION_DEGATS_PROPOSES_SUCCESS"
export const FETCH_LOCATION_DEGATS_PROPOSES_ERROR =
	"FETCH_LOCATION_DEGATS_PROPOSES_ERROR"

export const fetchLocationDegatsProposesBegin = () => ({
	type: FETCH_LOCATION_DEGATS_PROPOSES_BEGIN,
})

export const fetchLocationDegatsProposesSuccess = (payload) => ({
	type: FETCH_LOCATION_DEGATS_PROPOSES_SUCCESS,
	payload,
})

export const fetchLocationDegatsProposesError = (payload) => ({
	type: FETCH_LOCATION_DEGATS_PROPOSES_ERROR,
	payload,
})

export function fetchLocationDegatsProposes(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLocationDegatsProposesBegin())
		const params = new URLSearchParams(
			Object.entries(kwargs).filter(
				([, v]) => v !== null && v !== undefined,
			),
		)
		return fetch(`${URL}api/location/degats-proposes?${params}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLocationDegatsProposesSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchLocationDegatsProposesError))
	}
}

export const POST_LOCATION_BEGIN = "POST_LOCATION_BEGIN"
export const POST_LOCATION_SUCCESS = "POST_LOCATION_SUCCESS"
export const POST_LOCATION_ERROR = "POST_LOCATION_ERROR"
export const POST_LOCATION_RESET = "POST_LOCATION_RESET"

export const postLocationBegin = () => ({
	type: POST_LOCATION_BEGIN,
})

export const postLocationError = (error) => ({
	type: POST_LOCATION_ERROR,
	payload: { error },
})

export const postLocationReset = () => ({
	type: POST_LOCATION_RESET,
})

export const postLocationSuccess = (payload) => ({
	type: POST_LOCATION_SUCCESS,
	payload,
})

export function postLocation(formData) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postLocationBegin())
		return fetch(`${URL}api/locations`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				json = {
					...json,
					location: {
						...json.location,
						photosAvant: json.location.photosAvant.map((p) =>
							normalizePhoto(p),
						),
						photosApres: json.location.photosApres.map((p) =>
							normalizePhoto(p),
						),
						transactionsv2: json.location.transactionsv2.map(
							(t) => ({
								...t,
								quittance: normalizePdf(t.quittance),
								facture: normalizePdf(t.facture),
							}),
						),
					},
				}
				dispatch(postLocationSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, postLocationError, { silent: true }))
	}
}

export const FETCH_CLIENT_LOCATION_BEGIN = "FETCH_CLIENT_LOCATION_BEGIN"
export const FETCH_CLIENT_LOCATION_SUCCESS = "FETCH_CLIENT_LOCATION_SUCCESS"
export const FETCH_CLIENT_LOCATION_ERROR = "FETCH_CLIENT_LOCATION_ERROR"
export const FETCH_CLIENT_LOCATION_RESET = "FETCH_CLIENT_LOCATION_RESET"

export const fetchClientLocationBegin = () => ({
	type: FETCH_CLIENT_LOCATION_BEGIN,
})

export const fetchClientLocationError = (error) => ({
	type: FETCH_CLIENT_LOCATION_ERROR,
	payload: { error },
})

export const fetchClientLocationReset = () => ({
	type: FETCH_CLIENT_LOCATION_RESET,
})

export const fetchClientLocationSuccess = (client) => ({
	type: FETCH_CLIENT_LOCATION_SUCCESS,
	payload: { client },
})

export function fetchClientLocation(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchClientLocationBegin())
		let url = `${URL}api/locationclient?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchClientLocationSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchClientLocationError))
	}
}

export function setLocation(loc) {
	return (dispatch) => {
		dispatch({
			type: "UPDATE_LOCATION",
			value: loc,
		})
		return Promise.resolve()
	}
}

export const updateLocationObject = (location) => {
	return (dispatch) => {
		dispatch({
			type: "UPDATE_LOCATION",
			value: location,
		})
		return Promise.resolve()
	}
}

// Revue 5 (décisions Jordan 4 et 6) : « Annuler la restitution » /
// « Annuler l'état des lieux » (boss / admin, refus serveur sinon). Résout
// {ok, avertissements} ou {erreur} — affichée dans le modal de confirmation.
export const ANNULER_LOCATION_ERROR = "ANNULER_LOCATION_ERROR"

export function annulerLocation(id, action) {
	return (dispatch, getState) => {
		const { token } = getState().navInfo.login
		let erreur = null
		return fetch(`${URL}api/location/annuler`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ id, action }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => ({
				ok: true,
				avertissements: json.avertissements || [],
			}))
			.catch(
				catchApiError(
					dispatch,
					(payload) => {
						erreur = payload.message
						return { type: ANNULER_LOCATION_ERROR, payload }
					},
					{ silent: true },
				),
			)
			.then((res) => res || { erreur })
	}
}
